import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DEFAULT_BRANDING = {
  app_name: "ViralTubeAI",
  tagline: "Analizador de Videos de YouTube con IA",
  colors: { primary: "#8B5CF6", secondary: "#EC4899", accent: "#06B6D4" },
  assets: { logo_main: null, logo_dark: null, logo_light: null, favicon: null },
  is_default: true,
};

const BrandingContext = createContext({ branding: DEFAULT_BRANDING, refreshBranding: () => {} });

const applyBranding = (b) => {
  const root = document.documentElement;
  root.style.setProperty("--brand-primary", b.colors.primary);
  root.style.setProperty("--brand-secondary", b.colors.secondary);
  root.style.setProperty("--brand-accent", b.colors.accent);
  const customColors =
    b.colors.primary !== DEFAULT_BRANDING.colors.primary ||
    b.colors.secondary !== DEFAULT_BRANDING.colors.secondary ||
    b.colors.accent !== DEFAULT_BRANDING.colors.accent;
  root.classList.toggle("brand-custom", customColors);
  if (b.app_name !== DEFAULT_BRANDING.app_name) {
    document.title = `${b.app_name} | ${b.tagline}`;
  }
  if (b.assets.favicon) {
    let link = document.querySelector('link[rel="icon"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = `${process.env.REACT_APP_BACKEND_URL}${b.assets.favicon}`;
  }
};

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(DEFAULT_BRANDING);

  const refreshBranding = useCallback(() => {
    axios
      .get(`${API}/branding`)
      .then((r) => {
        setBranding(r.data);
        applyBranding(r.data);
      })
      .catch(() => {});
  }, []);

  useEffect(refreshBranding, [refreshBranding]);

  return (
    <BrandingContext.Provider value={{ branding, refreshBranding }}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = () => useContext(BrandingContext);
